import Cookies from 'js-cookie';

export const CLIENT_FPID_COOKIE_NAME = 'cs_fpid';
export const CLIENT_FPID_EXPIRATION_DAYS = 365; // 1 year

const DEFAULT_CONSUMER = 'id=A0056099-8CC7YJYS05J7L89Y;type=WEB';

export type GetFpidProps = {
  consumer?: string;
};

/**
 * Fetches fpid for analytics identification and caches to decrease network calls.
 */
export const getFpid = async (props: GetFpidProps = {}) => {
  const { consumer = DEFAULT_CONSUMER } = props;
  const fpidCookie = Cookies.get(CLIENT_FPID_COOKIE_NAME);

  if (fpidCookie) {
    return fpidCookie;
  }

  /**
   * A fpid cookie is set by calling this service
   * That cookie has HttpOnly set for Apple's Intelligent Tracking Prevention (ITP)
   * which makes JS agnostic of this cookie.
   * Instead, we cache the value in a non-HttpOnly cookie for JS to access.
   */
  const response = await fetch('/ods.svc/retrieveFPIDCookie', {
    method: 'GET',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'OData-Version': '4.0',
      consumer,
    },
  })
    .then(response => {
      if (!response.ok) {
        return null;
      }
      return response.json();
    })
    .then(json => {
      if (!json?.value?.FPID) {
        console.error('Error FPID cookie missing in response');
        return null;
      }

      const value = json.value.FPID;

      Cookies.set(CLIENT_FPID_COOKIE_NAME, value, {
        expires: CLIENT_FPID_EXPIRATION_DAYS,
        sameSite: 'lax',
      });

      return value;
    })
    .catch(() => {
      console.error('Error fetching FPID cookie');
      return null;
    });

  return response;
};
